/**
 * Ověří zda platí zadaná podmínka.
 * Zápis přes arrow funkci [není možný]{@link https://github.com/microsoft/TypeScript/issues/34523}.
 * @param condition Podmínka.
 * @param message Chybová hláška.
 * @throws Vyhazuje chybu v případě nepravdivé podmínky.
 */
export function invariant(condition: any, message: string): asserts condition {
    if (!condition) {
        throw new Error(message);
    }
}
